export interface GstinRecord {
  gstin: string;
  legalEntityName: string;
  stateOfRegistration: string;
  certificateUrl?: string;
}

export interface CompanyRegistration {
  cin: string;
  legalName: string;
  incorporationDate: string;
  registeredAddress: string;
  certificateUrl?: string;
}

export interface FssaiLicence {
  id: string;
  state: string;
  licenceNumber: string;
  licenceType: "Central" | "State";
  issuingAuthority: string;
  validFrom: string;
  validTo: string;
  certificateUrl?: string;
}

// TODO(content): populate once ZenFresh has real, verifiable tax/corporate
// registration to publish. Deliberately null/empty, following this project's
// established honesty policy (see pressMentions.ts, leadership.ts) — a
// GSTIN, CIN, and FSSAI licence number are each a specific, checkable claim
// a visitor or auditor could verify against government records. Fabricating
// one would be materially worse than an inert placeholder.
export const GSTIN_RECORD: GstinRecord | null = null;
export const COMPANY_REGISTRATION: CompanyRegistration | null = null;
export const FSSAI_LICENCES: FssaiLicence[] = [];
